import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["isBgImage", "offsetPx", "$css"];
import React from 'react';
import styled, { css } from 'styled-components';
import { Div } from '../Styled';
import { useIntersectionObserver } from '../../hooks';
import { positionAbsolute } from '../../styling';
import Image from './Image';
var Observer = /*#__PURE__*/styled.div.withConfig({
  displayName: "DatoImageLoader__Observer",
  componentId: "sc-k7nonh-0"
})(["pointer-events:none;position:absolute;top:-", "px;right:0;bottom:-", "px;left:0;"], function (_ref) {
  var $offsetPx = _ref.$offsetPx;
  return $offsetPx;
}, function (_ref2) {
  var $offsetPx = _ref2.$offsetPx;
  return $offsetPx;
});
/**
 * ImageLoader will lazy load images right before they come into view (with a 60px preload buffer), using {@link IntersectionObserver}
 * Assumes images are uploaded to Dato, as it leverages the Dato imgix API to get webp versions of the images (for non svg)
 * By default it will take the width of the container. Set an explicit width using {@link $css} if needed.
 * To prevent reflow, {@link ImageProps.aspectRatio} (Width / Height) of the image should be passed in. This will create a placeholder container.
 * If using as background image, set {@link ImageProps.isBgImage} and it will cover the closest position relative parent.
 */

var DatoImageLoader = function DatoImageLoader(_ref3) {
  var isBgImage = _ref3.isBgImage,
      _ref3$offsetPx = _ref3.offsetPx,
      offsetPx = _ref3$offsetPx === void 0 ? 60 : _ref3$offsetPx,
      $css = _ref3.$css,
      rest = _objectWithoutProperties(_ref3, _excluded);

  var _useIntersectionObser = useIntersectionObserver(),
      elRef = _useIntersectionObser.elRef,
      isIntersecting = _useIntersectionObser.isIntersecting;

  return /*#__PURE__*/React.createElement(Div, _extends({
    $css: css(["", " ", ""], isBgImage ? css(["", ""], positionAbsolute()) : css(["position:relative;width:100%;"]), $css)
  }, rest), /*#__PURE__*/React.createElement(Observer, {
    $offsetPx: offsetPx,
    ref: elRef
  }), /*#__PURE__*/React.createElement(Image, _extends({
    visible: isIntersecting,
    isBgImage: isBgImage
  }, rest)));
};

export default DatoImageLoader;